// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonSide = "InsightFooter__buttonSide__yph-I";
export const fullWidth = "InsightFooter__fullWidth__7r7U4";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const inverted = "InsightFooter__inverted__qSsfZ";
export const left = "InsightFooter__left__S5NJQ";
export const medium = "500";
export const minWidth = "InsightFooter__minWidth__-7wOZ";
export const regular = "400";
export const right = "InsightFooter__right__-aOAG";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";